import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.175 6.763A9.99 9.99 0 0 1 23.067 8.93l2.539 2.531h-3.58a1 1 0 0 0 0 2h6a1 1 0 0 0 .889-.543 1 1 0 0 0 .11-.457v-6a1 1 0 1 0-2 0v3.591l-2.543-2.535a11.987 11.987 0 0 0-16.965 0 1 1 0 1 0 1.416 1.413 10 10 0 0 1 3.242-2.168M3.589 18.615a1 1 0 0 1 .386-.078h6a1 1 0 1 1 0 2h-3.58l2.538 2.531a9.99 9.99 0 0 0 14.135 0 1 1 0 1 1 1.415 1.413 11.99 11.99 0 0 1-16.965.001l-2.543-2.535v3.59a1 1 0 1 1-2 0v-6c0-.272.11-.52.286-.7l.01-.01a1 1 0 0 1 .318-.212"
    />
  </svg>
);
const SvgIconArrowsClockwise = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowsClockwise);
export default Memo;
